import * as React from "react";

interface Column {
    label?: string;
    flex?: number;
}

interface Props {
    className?: any;
    columns: Column[];
    rows: JSX.Element[][];
    labelsClass?: any;
    headerClass?: any;
}

class AdminTable extends React.Component<Props> {
    renderColumns(): JSX.Element[] {
        const columns: JSX.Element[] = this.props.columns.map((col) => (
            <h5 key={col.label} style={{ flex: col.flex ? col.flex : 1 }} className={"table-label " + this.props.labelsClass}>
                {col.label}
            </h5>
        ));
        return columns;
    }

    render(): JSX.Element {
        const { rows, className, headerClass } = this.props;

        const columns: JSX.Element[] = this.renderColumns();

        const renderRow = ({ item }: { item: JSX.Element[] }): JSX.Element => {
            const items: JSX.Element[] = item.map((e, i) => (
                <div
                    style={{ flex: this.props.columns[i].flex ? this.props.columns[i].flex : 1 }}
                    className={"table-element"}
                    key={e.key + i.toString()}
                >
                    {e}
                </div>
            ));
            return <div className={"table-row"}>{items}</div>;
        };

        return (
            <div className={"table-container " + className}>
                <div className={"table-row table-header " + headerClass}>{columns}</div>
                <div className={"table-content"}>{rows.map((r) => renderRow({ item: r }))}</div>
            </div>
        );
    }
}

export default AdminTable;



// WEBPACK FOOTER //
// ./src/core/ui/admin-table.tsx